module.exports = ".time-input{\r\n    background-color: #ececec;\r\n    border: none;\r\n    width: 35px;\r\n}\r\n\r\n.time-input:focus {\r\n    outline: none;\r\n    -webkit-box-shadow: none;\r\n            box-shadow: none;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/time-picker/time-picker.component.css
// module id = ./src/app/shared/time-picker/time-picker.component.css
// module chunks = main